import { ValidationBuilder } from "@ajayvikas/react-fluent-validation";
import { RecipientInformation } from "../types";
import t from "../i18n";

export const recipientInfoValidator = new ValidationBuilder<RecipientInformation>()
    //.ensure("senderMobile")
    //.required().withMessage(t.validations("sender_mobile_required"))
    .ensure("recipientMobile")
    .required().withMessage(t.validations("recipient_mobile_required"))
    .ensure("recipientFullName")
    .required().withMessage(t.validations("recipient_name_required"))
    .ensure("recipientEmail")
    .required().withMessage(t.validations("recipient_email_required"))
    .email().withMessage(t.validations("valid_email"))
    .ensure("confirmRecipientEmail")
        .satisfies((prop, o) => !!o.recipientEmail).withMessage(t.validations("recipient_email_required"))
        .satisfies((prop, o) => o.recipientEmail === prop).withMessage(t.validations("recipient_email_confirm"))
    // .ensure("recipientMessage")
    .ensure("senderFullName").required().withMessage(t.validations("sender_name_required"))
    .build();